const serieAContent = {
  preview: `Serie A 2024/25 has seen Inter Milan establish themselves as the dominant force in Italian 
  football, with Simone Inzaghi's side combining defensive solidity with devastating counter-attacking 
  football. AC Milan seek to reclaim their status as Italy's top club while Juventus, under new management, 
  attempt to rebuild their legendary winning culture.`,

  keyStories: [
    {
      title: "Inter's Dominance",
      desc: "The Nerazzurri have built a squad capable of competing at the highest European level while dominating domestically."
    },
    {
      title: "Napoli's Rebuild",
      desc: "Following their stunning Scudetto, Napoli face the challenge of maintaining standards amid significant squad changes."
    },
    {
      title: "Juventus' New Era",
      desc: "The Old Lady seeks to return to domestic dominance under their new coaching setup."
    },
  ],

  titleContenders: ["Inter Milan", "AC Milan", "Juventus", "Napoli", "Atalanta"],

  fullPreview: `
    <h3>Serie A 2024/25 — Complete Analysis</h3>
    <p>Italian football continues its renaissance, with Serie A clubs performing strongly in European 
    competition and producing some of the continent's most tactically sophisticated football.</p>
    
    <h3>PitchFacts Prediction</h3>
    <p>Inter Milan are favorites to retain the Scudetto based on squad quality and managerial continuity, 
    though AC Milan and Juventus possess the quality to mount serious challenges.</p>
  `,
};

export default serieAContent;